module.exports = __webpack_public_path__ + "e469f536b40c087012270651987f5d1d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/quar_spec.png
 ** module id = 1074
 ** module chunks = 0
 **/